import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
// Auth UI removed per request

function Sidebar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const FileIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0,0,256,256">
      <g fill="#d1d5db" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{mixBlendMode: 'normal'}}>
        <g transform="scale(10.66667,10.66667)">
          <path d="M5.75,3c-0.35548,0.00019 -0.68414,0.18906 -0.86328,0.49609l-1.75,3c-0.08939,0.1529 -0.13657,0.32679 -0.13672,0.50391v12c0,1.09306 0.90694,2 2,2h14c1.09306,0 2,-0.90694 2,-2v-12c-0.00015,-0.17711 -0.04733,-0.35101 -0.13672,-0.50391l-1.75,-3c-0.17914,-0.30704 -0.5078,-0.4959 -0.86328,-0.49609zM6.32422,5h11.35156l1.16602,2h-13.68359zM10,9h4c0.552,0 1,0.448 1,1c0,0.552 -0.448,1 -1,1h-4c-0.552,0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1z"></path>
        </g>
      </g>
    </svg>
  );

  const HomeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0,0,256,256">
      <g fill="currentColor" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{mixBlendMode: 'normal'}}>
        <g transform="scale(10.66667,10.66667)">
          <path d="M12,2.09961l-11,9.90039h3v9h6v-6h4v6h6v-9h3z"></path>
        </g>
      </g>
    </svg>
  );

  const FolderIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 6a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6z" fill="currentColor"/>
    </svg>
  );

  const ProfileIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 12c2.761 0 5-2.239 5-5s-2.239-5-5-5-5 2.239-5 5 2.239 5 5 5zm0 2c-4.337 0-8 2.239-8 5v1h16v-1c0-2.761-3.663-5-8-5z"/>
    </svg>
  );

  const CrownIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 26 26" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}}>
      <g>
        <path style={{opacity: 0.854}} fill="currentColor" d="M 25.5,6.5 C 25.5,7.83333 25.5,9.16667 25.5,10.5C 23.023,12.4159 22.023,15.0825 22.5,18.5C 15.8333,18.5 9.16667,18.5 2.5,18.5C 2.97699,15.0825 1.97699,12.4159 -0.5,10.5C -0.5,9.16667 -0.5,7.83333 -0.5,6.5C 0.833333,6.5 2.16667,6.5 3.5,6.5C 5.2216,13.4772 7.38827,13.8105 10,7.5C 10.4955,5.5273 10.6621,3.5273 10.5,1.5C 11.8333,1.5 13.1667,1.5 14.5,1.5C 13.979,5.71888 15.1457,9.38555 18,12.5C 20.2645,11.0842 21.4312,9.08423 21.5,6.5C 22.8333,6.5 24.1667,6.5 25.5,6.5 Z"/>
      </g>
      <g>
        <path style={{opacity: 0.98}} fill="currentColor" d="M 3.5,20.5 C 9.5,20.5 15.5,20.5 21.5,20.5C 21.5,21.5 21.5,22.5 21.5,23.5C 15.5,23.5 9.5,23.5 3.5,23.5C 3.5,22.5 3.5,21.5 3.5,20.5 Z"/>
      </g>
    </svg>
  );

  const HamburgerIcon = () => (
    <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor">
      <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
    </svg>
  );

  const CloseIcon = () => (
    <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor">
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
    </svg>
  );

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Mobile Header */}
      <div 
        style={{
          display: 'block',
          position: 'fixed',
          top: '0',
          left: '0',
          right: '0',
          height: '50px',
          backgroundColor: '#242938',
          borderBottom: '1px solid #2a2d3a',
          padding: '0 16px',
          zIndex: '1000'
        }}
        className="md:hidden"
      >
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          height: '100%'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{ color: '#fbbf24' }}>
              <FileIcon />
            </div>
            <Link to="/" style={{ fontSize: '14px', fontWeight: '600', color: '#e2e8f0', textDecoration: 'none', transition: 'color 0.2s ease' }} onMouseEnter={(e) => e.target.style.color = '#fbbf24'} onMouseLeave={(e) => e.target.style.color = '#e2e8f0'}>LargeTransfer</Link>
          </div>
          <button
            onClick={toggleMobileMenu}
            style={{
              background: 'none',
              border: 'none',
              color: '#9ca3af',
              cursor: 'pointer',
              padding: '4px',
              borderRadius: '2px',
              transition: 'color 0.2s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = '#e2e8f0'}
            onMouseLeave={(e) => e.target.style.color = '#9ca3af'}
          >
            {isMobileMenuOpen ? <CloseIcon /> : <HamburgerIcon />}
          </button>
        </div>
      </div>

      {/* Desktop Sidebar */}
      <div 
        style={{
          position: 'fixed',
          top: '0',
          left: '0',
          width: '220px',
          height: '100vh',
          backgroundColor: '#242938',
          borderRight: '1px solid #2a2d3a',
          zIndex: '999',
          display: 'none'
        }}
        className="md:block"
      >
        {/* Logo */}
        <div style={{ 
          padding: '20px 24px',
          borderBottom: '1px solid #2a2d3a'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ color: '#fbbf24' }}>
              <FileIcon />
            </div>
            <span style={{ fontSize: '16px', fontWeight: '600', color: '#e2e8f0' }}>
              LargeTransfer
            </span>
          </div>
        </div>

        {/* Navigation */}
        <nav style={{ padding: '16px 0' }}>
          <Link
            to="/"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '10px 24px',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: '500',
              color: isActive('/') ? '#1877f2' : '#9ca3af',
              backgroundColor: 'transparent',
              borderRight: isActive('/') ? '3px solid #1877f2' : '3px solid transparent',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              if (!isActive('/')) {
                e.currentTarget.style.backgroundColor = '#2a2d3a';
                e.currentTarget.style.color = '#e2e8f0';
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive('/')) {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = '#9ca3af';
              }
            }}
          >
            <HomeIcon />
            <span>Home</span>
          </Link>

          <Link
            to="/uploads"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '10px 24px',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: '500',
              color: isActive('/uploads') ? '#1877f2' : '#9ca3af',
              backgroundColor: 'transparent',
              borderRight: isActive('/uploads') ? '3px solid #1877f2' : '3px solid transparent',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              if (!isActive('/uploads')) {
                e.currentTarget.style.backgroundColor = '#2a2d3a';
                e.currentTarget.style.color = '#e2e8f0';
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive('/uploads')) {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = '#9ca3af';
              }
            }}
          >
            <FolderIcon />
            <span>My Files</span>
          </Link>

          <Link
            to="/profile"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '10px 24px',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: '500',
              color: isActive('/profile') ? '#1877f2' : '#9ca3af',
              backgroundColor: 'transparent',
              borderRight: isActive('/profile') ? '3px solid #1877f2' : '3px solid transparent',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              if (!isActive('/profile')) {
                e.currentTarget.style.backgroundColor = '#2a2d3a';
                e.currentTarget.style.color = '#e2e8f0';
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive('/profile')) {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = '#9ca3af';
              }
            }}
          >
            <ProfileIcon />
            <span>Profile</span>
          </Link>

          <Link
            to="/pricing"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '10px 24px',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: '500',
              color: isActive('/pricing') ? '#1877f2' : '#9ca3af',
              backgroundColor: 'transparent',
              borderRight: isActive('/pricing') ? '3px solid #1877f2' : '3px solid transparent',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              if (!isActive('/pricing')) {
                e.currentTarget.style.backgroundColor = '#2a2d3a';
                e.currentTarget.style.color = '#e2e8f0';
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive('/pricing')) {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = '#9ca3af';
              }
            }}
          >
            <CrownIcon />
            <span>Premium</span>
          </Link>

          {/* Auth UI removed */}
        </nav>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div 
          style={{
            position: 'fixed',
            top: '50px',
            left: '0',
            right: '0',
            bottom: '0',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '998',
            backdropFilter: 'blur(4px)'
          }}
          className="md:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        >
          <div 
            style={{
              width: '280px',
              height: '100%',
              backgroundColor: '#242938',
              borderRight: '1px solid #2a2d3a',
              padding: '16px 0'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <nav>
              <Link
                to="/"
                onClick={() => setIsMobileMenuOpen(false)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  padding: '12px 24px',
                  textDecoration: 'none',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: isActive('/') ? '#1877f2' : '#9ca3af',
                  backgroundColor: 'transparent',
                  borderRight: isActive('/') ? '3px solid #1877f2' : '3px solid transparent',
                  transition: 'all 0.2s ease'
                }}
              >
                <HomeIcon />
                <span>Home</span>
              </Link>

              <Link
                to="/uploads"
                onClick={() => setIsMobileMenuOpen(false)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  padding: '12px 24px',
                  textDecoration: 'none',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: isActive('/uploads') ? '#1877f2' : '#9ca3af',
                  backgroundColor: 'transparent',
                  borderRight: isActive('/uploads') ? '3px solid #1877f2' : '3px solid transparent',
                  transition: 'all 0.2s ease'
                }}
              >
                <FolderIcon />
                <span>My Files</span>
              </Link>

              <Link
                to="/profile"
                onClick={() => setIsMobileMenuOpen(false)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  padding: '12px 24px',
                  textDecoration: 'none',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: isActive('/profile') ? '#1877f2' : '#9ca3af',
                  backgroundColor: 'transparent',
                  borderRight: isActive('/profile') ? '3px solid #1877f2' : '3px solid transparent',
                  transition: 'all 0.2s ease'
                }}
              >
                <ProfileIcon />
                <span>Profile</span>
              </Link>

              <Link
                to="/pricing"
                onClick={() => setIsMobileMenuOpen(false)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  padding: '12px 24px',
                  textDecoration: 'none',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: isActive('/pricing') ? '#1877f2' : '#9ca3af',
                  backgroundColor: 'transparent',
                  borderRight: isActive('/pricing') ? '3px solid #1877f2' : '3px solid transparent',
                  transition: 'all 0.2s ease'
                }}
              >
                <CrownIcon />
                <span>Premium</span>
              </Link>
            </nav>
          </div>
        </div>
      )}

      
    </>
  );
}

export default Sidebar; 